import { AiOutlineCheckSquare, AiOutlineFileSearch } from "react-icons/ai";
import { customerType } from "types";

type clientActions = {
    [customer in customerType]?: {
        [key: string]: {
            name_action: string;
            state: string;
            state_to_update: string;
            state_to_update_name: string;
            icon: React.ReactNode;
        };
    } | undefined;
}

export const CLIENT_ACTIONS: clientActions = {
    bolivar_cali: {
        validar: {
            name_action: "Validar",
            state: "to_validate",
            state_to_update: "to_approve",
            state_to_update_name: "por aprobar",
            icon: < AiOutlineFileSearch />
        },
        aprobar: {
            name_action: "Aprobar",
            state: "to_approve",
            state_to_update: "approved",
            state_to_update_name: "aprobado",
            icon: <AiOutlineCheckSquare />
        },
    },
    capital: {
        aprobar: {
            name_action: "Aprobar",
            state: "to_approve",
            state_to_update: "approved",
            state_to_update_name: "aprobado",
            icon: <AiOutlineCheckSquare />
        },
    },
    capital_bogota: {
        aprobar: {
            name_action: "Aprobar",
            state: "to_approve",
            state_to_update: "approved",
            state_to_update_name: "aprobado",
            icon: <AiOutlineCheckSquare />
        },
    }
};